import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "relative size-18",
    "aria-hidden": "true"
};
const _hoisted_2 = {
    class: "absolute left-1/2 top-1/2 size-45.25 max-w-none -translate-x-1/2 -translate-y-1/2 select-none pointer-events-none",
    viewBox: "0 0 181 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    focusable: "false"
};
const _hoisted_3 = { filter: "url(#module-illustration-glow)" };
const _hoisted_4 = ["fill"];
const _hoisted_5 = ["x", "y", "width", "height", "viewBox"];
const _hoisted_6 = ["d", "fill", "fill-rule", "clip-rule", "stroke", "stroke-width"];
import { computed } from "vue";
const SVG_PATH = "M47.2393 15.8375V14.7487C47.2357 13.4303 46.3885 12.3172 45.2777 11.611C39.2398 8.03854 33.2198 4.50082 27.2211 0.994416C26.3132 0.483065 25.3235 0.281307 24.3018 0.25L23.2943 0.267393C22.0839 0.357836 20.9696 0.726565 19.9051 1.35271L13.3617 5.20002L2.43944 11.6354C1.24326 12.3415 0.442244 13.5034 0.324761 14.8705L0.26424 15.0861L0.25 15.4897C0.2678 17.0168 0.944213 17.949 2.15464 18.8465C3.99519 19.9422 5.82506 21.0415 7.6407 22.1511L2.3718 25.3027C1.13646 26.0576 0.285601 27.2612 0.25356 28.7013V29.3448C0.296281 30.625 0.937093 31.7972 2.04427 32.5138C3.6997 33.5122 5.33733 34.5175 6.96428 35.5298L2.29348 38.3439C1.12222 39.0744 0.310521 40.2467 0.25356 41.6173V42.3582C0.299841 43.6453 0.986934 44.8071 2.07987 45.5341L20.1792 56.4117C21.0052 56.8743 21.8703 57.2465 22.8386 57.25H24.7646C25.7223 57.25 26.5731 56.8813 27.3884 56.4186L45.4237 45.5828C46.4703 44.8871 47.25 43.8018 47.25 42.553V41.5129C47.2429 40.2745 46.5451 39.1301 45.4771 38.4622C43.8394 37.4847 42.2196 36.4968 40.6176 35.4984L45.5162 32.5277C46.5024 31.8668 47.2464 30.7815 47.25 29.5883V28.4995C47.2535 27.1533 46.3991 26.0367 45.2635 25.3271C43.4763 24.2696 41.7034 23.2017 39.9412 22.1268L45.3667 18.8778C46.4597 18.2134 47.2429 17.1002 47.25 15.834L47.2393 15.8375ZM3.47186 13.2842L21.2259 2.85546C22.8386 1.9058 24.8892 1.98929 26.4841 2.92851L44.1385 13.319C44.8576 13.7399 45.2741 14.4913 45.2777 15.267C45.2777 16.0914 44.8505 16.808 44.1136 17.2463L36.5733 21.7476L26.5731 27.7273C24.5973 28.7917 22.212 28.6213 20.3929 27.3655L3.25114 17.1142C2.57116 16.7072 2.26144 15.8688 2.29704 15.1453C2.33264 14.38 2.77409 13.6982 3.47542 13.2842H3.47186ZM44.3058 30.8685L26.744 41.4712C25.8504 42.0103 24.8999 42.3999 23.8283 42.3756C22.9988 42.3582 22.0839 42.2156 21.3434 41.7703L3.25826 30.8615C2.09411 30.1588 2.00155 28.4891 2.84885 27.5568C2.99837 27.376 3.08025 27.2612 3.27962 27.1429L9.75537 23.2747L20.0048 29.3761C22.3544 30.7745 25.3805 30.698 27.7123 29.3066L37.8158 23.2712L44.1171 27.0455C44.8113 27.4594 45.2136 28.1065 45.2635 28.8509C45.3133 29.5988 45.0321 30.4371 44.3094 30.8754L44.3058 30.8685ZM21.0372 54.5437L3.39354 43.9479C2.72069 43.5444 2.32196 42.8487 2.29348 42.1182C2.26144 41.3772 2.57828 40.5772 3.2725 40.1597L9.07896 36.6499L19.8517 43.1791C22.3616 44.6993 25.3627 44.6749 27.8263 43.12L38.4922 36.6429L44.078 39.9997C44.7651 40.4137 45.2065 41.0503 45.2635 41.8155C45.3204 42.546 45.0392 43.4157 44.3236 43.847L33.0631 50.6198L26.3916 54.6272C24.7077 55.6394 22.6927 55.5351 21.0408 54.5402L21.0372 54.5437Z";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ModuleIllustration',
    props: {
        svgPath: { default: SVG_PATH },
        viewBox: { default: "0 0 48 58" },
        iconColor: { default: "var(--colors-indigo-300)" },
        glowColor: { default: "var(--colors-indigo-100)" },
        fillRule: { default: "nonzero" },
        stroked: { type: Boolean, default: true }
    },
    setup(__props) {
        const props = __props;
        const iconWidth = computed(() => parseFloat(props.viewBox.split(" ")[2]));
        const iconHeight = computed(() => parseFloat(props.viewBox.split(" ")[3]));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(), _createElementBlock("svg", _hoisted_2, [
                    _createElementVNode("g", _hoisted_3, [
                        _createElementVNode("circle", {
                            cx: "90.5",
                            cy: "90.5",
                            r: "36.5",
                            fill: __props.glowColor
                        }, null, 8 /* PROPS */, _hoisted_4)
                    ]),
                    (_openBlock(), _createElementBlock("svg", {
                        x: (181 - iconWidth.value) / 2,
                        y: (181 - iconHeight.value) / 2,
                        width: iconWidth.value,
                        height: iconHeight.value,
                        viewBox: __props.viewBox,
                        fill: "none"
                    }, [
                        _createElementVNode("path", {
                            d: __props.svgPath,
                            fill: __props.iconColor,
                            "fill-rule": __props.fillRule,
                            "clip-rule": __props.fillRule,
                            stroke: __props.stroked ? __props.iconColor : undefined,
                            "stroke-width": __props.stroked ? 0.5 : undefined
                        }, null, 8 /* PROPS */, _hoisted_6)
                    ], 8 /* PROPS */, _hoisted_5)),
                    _cache[0] || (_cache[0] = _createElementVNode("defs", null, [
                        _createElementVNode("filter", {
                            id: "module-illustration-glow",
                            x: "0",
                            y: "0",
                            width: "181",
                            height: "181",
                            filterUnits: "userSpaceOnUse",
                            "color-interpolation-filters": "sRGB"
                        }, [
                            _createElementVNode("feFlood", {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix"
                            }),
                            _createElementVNode("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            _createElementVNode("feGaussianBlur", {
                                stdDeviation: "27",
                                result: "effect1_foregroundBlur"
                            })
                        ])
                    ], -1 /* CACHED */))
                ]))
            ]));
        };
    }
});
